import React from "react";
import HairServImg from "../HairBotox/HairServImg";
import SmokeyLilacImg from "./../../../../Images/Blog/Top 10 hairColor/Smokey Lilac.png"

const SmokeyLilac = () => {
  return (
    <div className="blogHead-content">
      <HairServImg hairBotoxImg={SmokeyLilacImg} />
      <h2>9. Smokey Lilac</h2>
      <p>
        For those who love to experiment with unconventional colors, Smokey
        Lilac is a trendy choice in 2024. As part of the <a href="https://scentlifestyle.com/top-10-trending-women-hair-colours-and-highlights-for-2024">Top 10 Trending Women
        Hair Colours & Highlights for 2024</a>, this cool, muted lavender shade adds
        a touch of mystery and sophistication to your look. Smokey Lilac is
        perfect for those who want to embrace a unique and edgy style. This
        color works well on lighter base colors and can be customized with
        various intensities, from soft pastels to bold purples.
      </p>
    </div>
  );
};

export default SmokeyLilac;
